// extracted by mini-css-extract-plugin
export default {"outline":"TableBody_outline__nRZaP","body":"TableBody_body__E6mAO","nodata":"TableBody_nodata__PuFNh"};